var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', [_vm.newestNotification && _vm.$permissions.has(_vm.$permissions.consts.MY_NOTIFICATION_LATEST) ? _c('div', {
    staticClass: "ml-auto d-flex align-items-center"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'BranchNotificationDetail',
        params: {
          notification_id: _vm.newestNotification.id
        }
      }
    }
  }, [_c('i', {
    class: {
      'fa fa-envelope-o text-danger': !_vm.newestNotification.is_read,
      'fa fa-envelope-open-o text-black': _vm.newestNotification.is_read
    }
  }), _c('a', {
    staticClass: "ml-2 text-black",
    class: {
      'text-danger': !_vm.newestNotification.is_read
    }
  }, [_vm._v(" " + _vm._s(_vm.newestNotification.title) + " : " + _vm._s(_vm.format(new Date(_vm.newestNotification.publish_at), 'MM/dd HH:mm')) + " ")])])], 1) : _vm._e()])], 1)]), _c('b-card', [_c('div', {
    staticClass: "row d-flex mb-2 mb-xl-2 justify-content-between"
  }, [_c('div', {
    staticClass: "col-6 d-flex align-items-center"
  }, [_c('h4', {
    staticClass: "mb-2 mb-xl-0 mr-2 font-weight-bold"
  }, [_vm._v("聊天室列表")])]), _c('div', {
    staticClass: "col-6 d-flex justify-content-end"
  }, [_c('div', {
    staticClass: "d-flex flex-column mr-2",
    staticStyle: {
      "flex": "1",
      "max-width": "400px"
    }
  }, [!_vm.showAdvancedSearch ? _c('b-input-group', [_c('b-form-input', {
    attrs: {
      "placeholder": "搜尋"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchChatRooms(true);
      }
    },
    model: {
      value: _vm.keyword,
      callback: function callback($$v) {
        _vm.keyword = $$v;
      },
      expression: "keyword"
    }
  }), _c('b-input-group-append', [_c('b-button', {
    on: {
      "click": function click($event) {
        return _vm.fetchChatRooms(true);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])], 1)], 1) : _vm._e(), _c('div', {
    staticClass: "text-right"
  }, [_c('a', {
    staticStyle: {
      "font-size": "0.9rem"
    },
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        _vm.showAdvancedSearch = !_vm.showAdvancedSearch;
      }
    }
  }, [_vm._v(" 進階搜尋 "), _c('i', {
    staticClass: "fa",
    class: _vm.showAdvancedSearch ? 'fa-angle-up' : 'fa-angle-down'
  })])])], 1), _vm.checkPermission([_vm.consts.CHATROOM_LIST_CREATE]) ? _c('b-button', {
    staticClass: "mb-2 mb-xl-0 ml-2 py-2 align-self-start",
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": _vm.handleCreate
    }
  }, [_c('i', {
    staticClass: "fa fa-plus",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("新增聊天室")]) : _vm._e()], 1)]), _vm.showAdvancedSearch ? _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('div', {
    staticClass: "card card-body p-3"
  }, [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "聊天室標題",
      "label-for": "search-title"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "search-title",
      "placeholder": "搜尋聊天室標題"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchChatRooms(true);
      }
    },
    model: {
      value: _vm.advancedQuery.title,
      callback: function callback($$v) {
        _vm.$set(_vm.advancedQuery, "title", $$v);
      },
      expression: "advancedQuery.title"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "聊天室成員名稱",
      "label-for": "search-member"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "search-member",
      "placeholder": "搜尋成員姓名"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchChatRooms(true);
      }
    },
    model: {
      value: _vm.advancedQuery.memberName,
      callback: function callback($$v) {
        _vm.$set(_vm.advancedQuery, "memberName", $$v);
      },
      expression: "advancedQuery.memberName"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "啟用狀態",
      "label-for": "search-enabled"
    }
  }, [_c('b-form-select', {
    attrs: {
      "id": "search-enabled",
      "options": _vm.enabledOptions
    },
    model: {
      value: _vm.advancedQuery.isEnabled,
      callback: function callback($$v) {
        _vm.$set(_vm.advancedQuery, "isEnabled", $$v);
      },
      expression: "advancedQuery.isEnabled"
    }
  })], 1)], 1), _c('b-col', {
    attrs: {
      "cols": "12",
      "md": "6"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "訊息內容",
      "label-for": "search-message"
    }
  }, [_c('b-form-input', {
    attrs: {
      "id": "search-message",
      "placeholder": "搜尋訊息內容"
    },
    on: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.fetchChatRooms(true);
      }
    },
    model: {
      value: _vm.advancedQuery.messageContent,
      callback: function callback($$v) {
        _vm.$set(_vm.advancedQuery, "messageContent", $$v);
      },
      expression: "advancedQuery.messageContent"
    }
  })], 1)], 1)], 1), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "12"
    }
  }, [_c('b-form-group', {
    attrs: {
      "label": "建立時間"
    }
  }, [_c('DateSearchPicker', {
    attrs: {
      "startedPlaceholder": "開始時間",
      "endedPlaceholder": "結束時間"
    },
    model: {
      value: _vm.advancedQuery.dateRange,
      callback: function callback($$v) {
        _vm.$set(_vm.advancedQuery, "dateRange", $$v);
      },
      expression: "advancedQuery.dateRange"
    }
  })], 1)], 1)], 1), _c('div', {
    staticClass: "d-flex justify-content-start mt-2"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "variant": "outline-primary"
    },
    on: {
      "click": _vm.resetAdvancedSearch
    }
  }, [_c('i', {
    staticClass: "fa fa-refresh mr-1"
  }), _vm._v("重置搜尋條件 ")]), _c('b-button', {
    attrs: {
      "variant": "primary"
    },
    on: {
      "click": function click($event) {
        return _vm.fetchChatRooms(true);
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search mr-1"
  }), _vm._v("搜尋 ")])], 1)], 1)])]) : _vm._e(), _c('b-table', {
    attrs: {
      "striped": "",
      "hover": "",
      "responsive": "",
      "items": _vm.chatrooms,
      "fields": _vm.fields,
      "busy": _vm.isLoading
    },
    scopedSlots: _vm._u([{
      key: "table-busy",
      fn: function fn() {
        return [_c('div', {
          staticClass: "text-center my-2"
        }, [_c('b-spinner', {
          staticClass: "align-middle"
        })], 1)];
      },
      proxy: true
    }, {
      key: "cell(is_enabled)",
      fn: function fn(data) {
        return [_c('b-badge', {
          attrs: {
            "variant": data.item.is_enabled ? 'success' : 'danger'
          }
        }, [_vm._v(" " + _vm._s(data.item.is_enabled ? '啟用' : '停用') + " ")])];
      }
    }, {
      key: "cell(created_at)",
      fn: function fn(data) {
        return [_vm._v(" " + _vm._s(_vm.format(new Date(data.item.created_at), 'yyyy/MM/dd HH:mm')) + " ")];
      }
    }, {
      key: "cell(actions)",
      fn: function fn(data) {
        return [_vm.checkPermission([_vm.consts.CHATROOM_LIST_MODIFY]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-warning",
            "to": {
              name: 'ChatroomEdit',
              params: {
                chatroomId: data.item.id
              }
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-lead-pencil mr-1"
        }), _vm._v("編輯 ")]) : _vm._e(), _vm.checkPermission([_vm.consts.CHATROOM_LIST_DELETE]) ? _c('b-button', {
          staticClass: "ml-2",
          attrs: {
            "variant": "inverse-danger"
          },
          on: {
            "click": function click($event) {
              return _vm.handleDelete(data.item);
            }
          }
        }, [_c('span', {
          staticClass: "mdi mdi-delete mr-1"
        }), _vm._v("刪除 ")]) : _vm._e(), _c('Tooltip', {
          scopedSlots: _vm._u([{
            key: "toggler",
            fn: function fn() {
              return [_vm.checkPermission([_vm.consts.CHATROOM_LIST_VIEW]) ? _c('b-button', {
                staticClass: "ml-2",
                attrs: {
                  "variant": "inverse-primary",
                  "to": {
                    name: 'ChatroomSenderList',
                    params: {
                      chatroomId: data.item.id
                    }
                  }
                }
              }, [_c('span', {
                staticClass: "mdi mdi-account-multiple mr-1"
              }), _vm._v("聊天室成員 ")]) : _vm._e()];
            },
            proxy: true
          }, {
            key: "content",
            fn: function fn() {
              return [_c('h3', {
                staticClass: "popover-header"
              }, [_vm._v("customer")]), (data.item.customers || []).length === 0 ? _c('div', {
                staticClass: "popover-body"
              }, [_vm._v("(無)")]) : _vm._l((data.item.customers || []).slice(0, 5), function (customer, index) {
                return _c('div', {
                  key: index,
                  staticClass: "popover-body"
                }, [_vm._v(" " + _vm._s(customer.name) + " ")]);
              }), _c('h3', {
                staticClass: "popover-header"
              }, [_vm._v("staff")]), (data.item.staffs || []).length === 0 ? _c('div', {
                staticClass: "popover-body"
              }, [_vm._v("(無)")]) : _vm._l(data.item.staffs, function (staff, index) {
                return _c('div', {
                  key: index,
                  staticClass: "popover-body"
                }, [_vm._v(" " + _vm._s(staff.name) + " ")]);
              })];
            },
            proxy: true
          }], null, true)
        }), _c('Tooltip', {
          on: {
            "show": function show($event) {
              return _vm.fetchLatestMessages(data.item.id);
            }
          },
          scopedSlots: _vm._u([{
            key: "toggler",
            fn: function fn() {
              return [_vm.checkPermission([_vm.consts.CHATROOM_LIST_VIEW_MSG]) ? _c('b-button', {
                staticClass: "ml-2",
                attrs: {
                  "variant": "inverse-info",
                  "to": {
                    name: 'ChatroomMessageList',
                    params: {
                      chatroomId: data.item.id
                    }
                  }
                }
              }, [_c('span', {
                staticClass: "mdi mdi-message-processing mr-1"
              }), _vm._v("訊息內容 ")]) : _vm._e()];
            },
            proxy: true
          }, {
            key: "content",
            fn: function fn() {
              return [_vm.loadingMessages[data.item.id] ? _c('div', {
                staticStyle: {
                  "padding": "16px 32px"
                }
              }, [_c('b-spinner', {
                attrs: {
                  "small": ""
                }
              }), _vm._v(" 載入中... ")], 1) : !_vm.chatroomMessages[data.item.id] || _vm.chatroomMessages[data.item.id].length === 0 ? _c('div', {
                staticStyle: {
                  "padding": "16px 32px"
                }
              }, [_vm._v(" (無訊息) ")]) : _c('div', {
                staticStyle: {
                  "padding": "8px 16px"
                }
              }, [_c('table', {
                staticClass: "latest-messages-table"
              }, [_c('tbody', _vm._l(_vm.chatroomMessages[data.item.id], function (message, index) {
                var _message$sender, _message$sender2;
                return _c('tr', {
                  key: index
                }, [_c('td', {
                  class: "latest-messages-table__sender latest-messages-table__sender--".concat(message === null || message === void 0 ? void 0 : (_message$sender = message.sender) === null || _message$sender === void 0 ? void 0 : _message$sender.type)
                }, [_vm._v(" " + _vm._s(message === null || message === void 0 ? void 0 : (_message$sender2 = message.sender) === null || _message$sender2 === void 0 ? void 0 : _message$sender2.name) + " ")]), _c('td', {
                  staticStyle: {
                    "min-width": "10rem"
                  }
                }, [_vm._v(_vm._s(_vm.truncateText(message.content, 30)))]), _c('td', {
                  staticClass: "latest-messages-table__time"
                }, [_vm._v(_vm._s(_vm.formatMessageTime(message.created_at)))])]);
              }), 0)])])];
            },
            proxy: true
          }], null, true)
        }), _vm.checkPermission([_vm.consts.CHATROOM_LIST_OPEN]) ? _c('b-form-checkbox', {
          staticClass: "ml-2 d-inline-block align-middle",
          attrs: {
            "switch": ""
          },
          on: {
            "change": function change($event) {
              return _vm.switchEnabled(data.item);
            }
          },
          model: {
            value: data.item.is_enabled,
            callback: function callback($$v) {
              _vm.$set(data.item, "is_enabled", $$v);
            },
            expression: "data.item.is_enabled"
          }
        }) : _vm._e()];
      }
    }])
  }), _c('div', {
    staticClass: "d-flex justify-content-center",
    staticStyle: {
      "margin-top": "80px"
    }
  }, [_c('CustomPagination', {
    attrs: {
      "currentPage": _vm.query.page,
      "totalRows": _vm.totalRows,
      "perPage": _vm.query.per_page
    },
    on: {
      "page-change": _vm.handlePageChange,
      "per-page-change": _vm.handlePerPageChange
    }
  })], 1)], 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }